import { alpha } from '@mui/material/styles';
import { IKpiResults, IKpiChartStoplightSettings, parseDate } from '@report-content';
import { Highcharts } from 'components/chart/Chart';
import { SeriesStoplightId } from './index';
import { TFunction } from 'i18next';

export function getKpiStoplight(
    stoplightSettings: IKpiChartStoplightSettings,
    kpiResults: IKpiResults[],
    minY: number,
    maxY: number,
    xColumn: string,
    measureLabel: string,
    t: TFunction,
): Highcharts.SeriesAreaOptions[] {
    const seriesBaseName = 'chart_label_stoplight_';
    let dataMax = maxY,
        dataMin = minY;

    // var tmp = chart.yAxis[0].getExtremes();
    // if (dataMax < tmp.dataMax) {
    //     dataMax = tmp.dataMax;
    // }
    //
    // if (series.metricMoreIsBetterInd == 'RANGE') {
    //     dataMin = dataMax;
    //     tmp = chart.yAxis[0].getExtremes();
    //     if (dataMin > tmp.dataMin) {
    //         dataMin = tmp.dataMin;
    //     }
    // }

    kpiResults.forEach((row) => {
        if (row.stoplight_bad_threshold !== null && dataMax < row.stoplight_bad_threshold) {
            dataMax = row.stoplight_bad_threshold;
        }
        if (row.stoplight_good_threshold !== null && dataMax < row.stoplight_good_threshold) {
            dataMax = row.stoplight_good_threshold;
        }
    });

    // if (series.metricMoreIsBetterInd == 'RANGE') {
    //     series.data.forEach((row) => {
    //         if (dataMin > row.mydata['raw_stoplight_bad_threshold_value']) {
    //             dataMin = row.mydata['raw_stoplight_bad_threshold_value'];
    //         }
    //         if (dataMin > row.mydata['raw_stoplight_good_threshold_value']) {
    //             dataMin = row.mydata['raw_stoplight_good_threshold_value'];
    //         }
    //     });
    // }
    const idRed = 'stoplight_red_series';

    const lowColor = alpha(stoplightSettings.stoplightColorForLowValues, 0.4);

    const redSeries: Highcharts.SeriesAreaOptions = {
        id: idRed,
        name: t(`kpi_chart.${seriesBaseName}unfavorable`, { measure: measureLabel }),
        seriesType: SeriesStoplightId,
        //@ts-ignore
        type: stoplightSettings.stoplightMoreIsBetter == 'RANGE' ? 'arearange' : 'area',
        threshold: stoplightSettings.stoplightMoreIsBetter == 'N' ? dataMax : null,
        data: [],
        enableMouseTracking: false,
        color: lowColor,
        zIndex: -1,
        // visible: chartState.legend ? (chartState.legend[idRed]?.visible ?? true) : true,
    };

    const idGreen = 'stoplight_green_series';

    const highColor = alpha(stoplightSettings.stoplightColorForHighValues, 0.4);

    const greenSeries: Highcharts.SeriesAreaOptions = {
        id: idGreen,
        name: t(`kpi_chart.${seriesBaseName}favorable`, { measure: measureLabel }),
        seriesType: 'stoplight',
        //@ts-ignore
        type: stoplightSettings.stoplightMoreIsBetter == 'RANGE' ? 'arearange' : 'area',
        threshold: stoplightSettings.stoplightMoreIsBetter == 'Y' ? dataMax : null,
        data: [],
        enableMouseTracking: false,
        color: highColor,
        zIndex: -1,
        // visible: chartState.legend ? (chartState.legend[idGreen]?.visible ?? true) : true,
    };

    kpiResults.forEach((row) => {
        if (row.stoplight_bad_threshold == null || row.stoplight_good_threshold == null) {
            return;
        }
        const xVal = String(row[xColumn]);
        if (null == xVal) {
            return;
        }
        const x = parseDate(xVal).getTime();
        const pointRed = { x: x, y: 0 };
        const pointGreen = { x: x, y: 0 };

        if (stoplightSettings.stoplightMoreIsBetter == 'Y') {
            pointRed.y = row.stoplight_bad_threshold;
            pointGreen.y = row.stoplight_good_threshold;
        } else {
            pointRed.y = row.stoplight_good_threshold;
            pointGreen.y = row.stoplight_bad_threshold;
        }
        redSeries.data!.push(pointRed);
        greenSeries.data!.push(pointGreen);
    });

    return [redSeries, greenSeries];
}
